export default __webpack_public_path__ + "static/media/Canada Camps[1].920e2ebc.png";